var map = {
	"./1_1.jpg": "5ae1",
	"./1_2.jpg": "f631",
	"./2_1.jpg": "acad",
	"./2_2.jpg": "9f5a",
	"./3_1.jpg": "37b8",
	"./3_2.jpg": "7c1f",
	"./4_1.jpg": "71eb",
	"./4_2.jpg": "d340",
	"./5_1.jpg": "3553",
	"./5_2.jpg": "cbf7",
	"./5_3.jpg": "9bad",
	"./6_1.jpg": "68e3",
	"./6_2.jpg": "fa5a",
	"./6_3.jpg": "9411"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7fa";